import { createTheme } from "@mui/material/styles";

const theme = createTheme({
  palette: {
    primary: {
      main: "#003366", // Azul escuro
    },
    secondary: {
      main: "#FFD700", // Amarelo
    },
    error: {
      main: "#FF0000", // Vermelho
    },
  },
  typography: {
    fontFamily: "Roboto, Arial, sans-serif",
    h1: {
      fontSize: "2.5rem",
      fontWeight: 700,
    },
    body1: {
      fontSize: "1rem",
    },
  },
  components: {
    MuiButton: {
      styleOverrides: {
        root: {
          borderRadius: "8px",
        },
      },
    },
    MuiTableHead: {
      styleOverrides: {
        root: {
          backgroundColor: "#003366", // Cor do fundo do cabeçalho
          "& .MuiTableCell-root": {
            color: "white", // Cor do texto
            fontWeight: "bold", // Negrito
            textAlign: "center", // Centralizado
          },
        },
      },
    },
  },
});

export default theme;
